import GameRankingItemShort from './GameRankingItemShort'
export default GameRankingItemShort;